import React, { useEffect, useRef, useState } from 'react';
import { LegalIssueOption } from '../../../slices/marketplace/loi-form/legal-issue-item';
import { LoiFormAnswerType } from '../../../slices/marketplace/loi-form/loi-form-answer-type.enum';
import { renderLoiAnswerReadonly } from '../../../slices/marketplace/loi-form/render-loi-answer-readonly';
import { renderLoiAnswerEditable } from '../../../slices/marketplace/loi-form/render-loi-answer-editable';

export interface VetValueInterpretationCellProps {
    value: string | null;
    answerType: LoiFormAnswerType;
    options?: LegalIssueOption[];
    ariaLabel: string;
    editable: boolean;
    onSave: (value: string | null) => Promise<void>;
}

export const VetValueInterpretationCell = (props: VetValueInterpretationCellProps) => {
    const { value, answerType, options, ariaLabel, editable, onSave } = props;
    const [draft, setDraft] = useState<string | null>(value);
    const [isSaving, setIsSaving] = useState(false);
    const savedValueRef = useRef<string | null>(value);
    const isFocusedRef = useRef(false);

    useEffect(() => {
        if (!isFocusedRef.current) {
            setDraft(value);
            savedValueRef.current = value;
        }
    }, [value]);

    if (!editable) {
        return <>{renderLoiAnswerReadonly(value, answerType, options)}</>;
    }

    const handleBlur = async () => {
        isFocusedRef.current = false;
        if (draft === savedValueRef.current) {
            return;
        }
        setIsSaving(true);
        const isSaved = await onSave(draft).then(
            () => true,
            () => false
        );
        if (isSaved) {
            savedValueRef.current = draft;
        }
        setIsSaving(false);
    };

    return (
        <>
            {renderLoiAnswerEditable({
                value: draft,
                answerType,
                options,
                ariaLabel,
                disabled: isSaving,
                onChange: setDraft,
                onFocus: () => {
                    isFocusedRef.current = true;
                },
                onBlur: handleBlur,
            })}
        </>
    );
};

export default VetValueInterpretationCell;
